// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1OLQX","inputWrap":"Table_inputWrap__224rp","col":"Table_col__2pl_s","bmiTooltip":"Table_bmiTooltip__3Z5SD"};